import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SERVICES } from "../../data/services";
import { LEGAL_LINKS, SITE } from "../../data/site";

const COMPANY = [
  { label: "How It Works", to: "/how-it-works" },
  { label: "For Businesses", to: "/for-businesses" },
  { label: "For Experts", to: "/for-experts" },
  { label: "About Us", to: "/about" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

const Col = ({ title, links, prefix }) => (
  <div>
    <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">{title}</h3>
    <ul className="mt-5 space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="text-sm text-slate-300 transition-colors hover:text-white" data-testid={`footer-${prefix}-${l.to.split("/").pop() || "home"}`}>{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="relative bg-[#0B1220] text-white" data-testid="site-footer">
    <div className="container-x grid gap-14 py-20 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Logo dark testId="footer-logo" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          A curated professional services marketplace connecting businesses with vetted independent experts across auditing, consulting, advisory, tax and law.
        </p>
      </div>
      <div className="grid gap-10 sm:grid-cols-3 lg:col-span-8">
        <Col title="Services" prefix="service" links={SERVICES.map((s) => ({ label: s.name, to: `/services/${s.slug}` }))} />
        <Col title="Company" prefix="company" links={COMPANY} />
        <Col title="Legal" prefix="legal" links={LEGAL_LINKS} />
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-3 py-8 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Trusted Leap. All rights reserved.</p>
        <p data-testid="footer-company-details">{SITE.legalEntity} · {SITE.companyDetails}</p>
      </div>
    </div>
  </footer>
);
